import { getUrlParams } from './get-url-params';

const TTCLID_COOKIE = '_ttclid_vp';
const TTP_COOKIE = '_ttp';
const TTCLID_TTL_DAYS = 30;

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'),
  );
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name: string, value: string, days: number) {
  if (typeof document === 'undefined') return;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires}; path=/; SameSite=Lax`;
}

export function persistTtclidFromUrl(): void {
  const ttclid = getUrlParams('ttclid');
  if (ttclid) writeCookie(TTCLID_COOKIE, ttclid, TTCLID_TTL_DAYS);
}

export function buildTtclid(): string | null {
  return readCookie(TTCLID_COOKIE) ?? getUrlParams('ttclid') ?? null;
}

export function buildTtp(): string | null {
  return readCookie(TTP_COOKIE);
}
